import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const MousePad = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M7.667 4.99c0-.185.15-.334.333-.334h7.667v10H3.334a3 3 0 0 1-3-3 .333.333 0 1 1 .667 0 2.333 2.333 0 0 0 2.333 2.333H15V5.323H8a.333.333 0 0 1-.333-.333Z" />
        <path d="M3.334 2.657A2.333 2.333 0 0 0 1 4.99v4.78a3 3 0 0 1 4.666 0V4.99a2.333 2.333 0 0 0-2.333-2.333Zm3 9V4.99a3 3 0 1 0-6 0v6.666h.667a2.333 2.333 0 1 1 4.666 0h.667Z" />
      </g>
    </svg>
  );
};

MousePad.category = 'product-category';

MousePad.displayName = 'MousePad';
